<template>
    <div class="tab-pane" :class="activeTab == 3 ? 'active': 'default'" id="messages" role="tabpanel" aria-labelledby="messages-tab">
    <!-- Modal -->
        <div class="modal fade" id="addressModal" tabindex="-1" role="dialog" aria-labelledby="addressModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Dirección</h5>
                        <button type="button" class="close step3" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="handleSubmitStep3('form-4')" data-vv-scope="form-4">
                            <div class="form-group">
                                <label class="form-label" for="exampleFormControlSelect2">Tipo de dirección</label>
                                <select data-vv-scope="form-4" @change="setTypeName($event)" v-model="address.AddressType.IdAddressType" name="addressType" class="form-control" id="exampleFormControlSelect2">
                                    <option value="1">Casa</option>
                                    <option value="2">Oficina</option>
                                    <option value="3">Otro</option>
                                </select>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Código Postal</label>
                                    <input v-model="address.ZipCode" data-vv-scope="form-4" name="extensionNumber" type="text" class="form-control" id="idNumber" placeholder="88888888">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="exampleFormControlSelect2">Provincia / Estado</label>
                                <select data-vv-scope="form-4" @change="setTypeName($event); setCity(); setDistrict(); setNeighborhood();" v-model="address.State.IdState" name="addressType" class="form-control" id="exampleFormControlSelect2">
                                    <option v-for="state in locations.default" :value="state.id" :key="state.id">
                                        {{ state.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="exampleFormControlSelect2">Cantón</label>
                                <select data-vv-scope="form-4" @change="setDistrict()" v-model="address.Canton" name="addressType" class="form-control" id="exampleFormControlSelect2">
                                    <option v-for="canton in cities" :value="canton.id" :key="canton.id">
                                        {{ canton.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="exampleFormControlSelect2">Distrito</label>
                                <select data-vv-scope="form-4" @change="setNeighborhood()" v-model="address.Distrito" name="addressType" class="form-control" id="exampleFormControlSelect2">
                                    <option v-for="district in districts" :value="district.id" :key="district.id">
                                        {{ district.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="exampleFormControlSelect2">Barrio</label>
                                <select data-vv-scope="form-4" v-model="address.Barrio" name="addressType" class="form-control" id="exampleFormControlSelect2">
                                    <option v-for="neighborhood in neighborhoods" :value="neighborhood.id" :key="neighborhood.id">
                                        {{ neighborhood.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Otras señas</label>
                                    <input :class="{ 'is-invalid': submitted && errors.has('form-4.direction') }" v-validate="{ required: true }" v-model="address.Direccion" data-vv-scope="form-4" name="direction" type="text" class="form-control" id="idNumber" placeholder="88888888">
                                    <div v-if="submitted && errors.has('form-4.direction')" class="invalid-feedback">{{ errors.first('form-4.direction') }}</div>
                                </div>
                            </div>
                            <div>
                                <button class="btn btn-primary">Agregar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-11 col-md-9 col-lg-5">
                <div class="form-container">
                    <form @submit.prevent="handleSubmitStep3('form-3')" data-vv-scope="form-3">
                        <h2>3. Información de envío en Costa Rica</h2>
                        <div class="form-group">
                            <label class="form-label" for="exampleFormControlSelect1">País de residencia</label>
                            <select v-model="Consignee.ResidenceCountry" class="form-control" id="residenceCountry">
                                <option value="CR">Costa Rica</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label class="form-label" for="exampleFormControlSelect2">Sucursal o servicio de entrega</label>
                            <select v-model="Consignee.IdSucursal" class="form-control" id="exampleFormControlSelect2">
                                <option value="1">Sabana Norte (Oficina Central)</option>
                                <option value="12">Guadalupe/Calle Blancos</option>
                                <option value="13">Entrega a domicilio</option>
                                <option value="14">Guachipelín Escazú / Distrito 4</option>
                            </select>
                        </div>
                        <div class="form-row">
                            <div class="col-md-12">
                                <p>Agregar dirección de entrega*</p>
                                <p class="advice-message">Puede agregar varias direcciones</p>
                            </div>
                        </div>
                        <div class="form-row" v-for="(phone, index) in addressesQuantity" :key="index">
                            <div class="col-md-12">
                                <div class="add-info flex-row">
                                    <div @click="addressesQuantity++; addresses.push({address: ''}) " class="circle-number flex-row" v-if="index == addressesQuantity - 1">
                                        <span>+</span>
                                    </div>
                                    <input v-model="addresses[index].address" @click="selectedAddressIndex = index; populateAddressInfo()" data-toggle="modal" data-target="#addressModal" v-validate="index == 0 ? { required: true } : null" :class="{ 'is-invalid': submitted && errors.has('form-3.showAddress' + ( index + 1 )) }" data-vv-scope="form-3"  :name="'showAddress' + ( index + 1 )" type="text" class="form-control">
                                    <div v-if="submitted && errors.has('form-3.showAddress' + ( index + 1 ))" class="invalid-feedback">{{ errors.first('form-3.showAddress' + ( index + 1 )) }}</div>
                                </div>
                            </div>
                        </div>
                        <button class="default-button default-button-form">Siguiente</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as locations from '../../services/ubicaciones.json';

export default {
    props: ['activeTab', 'Consignee', 'extraParams'],
    data() {
        return {
            submitted: false,
            selectedAddressIndex: '',
            locations: locations,
            addressesQuantity: 2,
            cities: [],
            districts: [],
            neighborhoods: [],
            addresses: [
                {address: ''},
                {address: ''},
            ],
            address: {
                IdAddress: '',
                Line1: '',
                Line2: '',
                City: '',
                ZipCode: '',
                State : {
                    IdState: 1,
                    StateName: 'San josé',
                },
                AddressType : {
                    IdAddressType: 1,
                    Type: 'Casa',
                },
                Provincia: '',
                Canton: '',
                Distrito: '',
                Barrio: '',
                Direccion: '',
            }
        }
    },
    mounted() {
        this.Consignee.ResidenceCountry = 'CR';
        this.setCity();
        this.setDistrict();
        this.setNeighborhood();
    },
    methods: {
        setTypeName(e) {
            this.address.State.StateName = e.target.options[e.target.selectedIndex].text;
        },
        setCity() {
            this.cities = this.locations.default[this.address.State.IdState - 1].cantones;
            this.address.Canton = this.cities[0].id;
        },
        setDistrict() {
            this.districts = this.cities[this.address.Canton - 1].distritos;
            this.address.Distrito = this.districts[0].id;
        },
        setNeighborhood() {
            this.neighborhoods = this.districts[this.address.Distrito - 1].barrios;
            this.address.Barrio = this.neighborhoods[0].id;
        },
        saveAddressData() {
            this.extraParams.addresses[this.selectedAddressIndex] = this.address;
            this.extraParams.addresses[this.selectedAddressIndex].IdAddress = this.selectedAddressIndex;
            this.extraParams.addresses[this.selectedAddressIndex].Provincia = this.address.State.IdState;
            this.extraParams.addresses[this.selectedAddressIndex].City = this.locations.default[this.address.State.IdState - 1].cantones[this.address.Canton - 1].label;
            this.addresses[this.selectedAddressIndex].address = this.address.State.StateName + ' ' + this.locations.default[this.address.State.IdState - 1].cantones[this.address.Canton - 1].label + ' ' + this.cities[this.address.Canton - 1].distritos[this.address.Distrito - 1].label + ' ' + this.districts[this.address.Distrito - 1].barrios[this.address.Barrio].label + ' ' + this.address.Direccion;
            this.extraParams.addresses[this.selectedAddressIndex].Line1 = this.addresses[this.selectedAddressIndex].address;

            this.address = {
                IdAddress: '',
                Line1: '',
                Line2: '',
                City: '',
                ZipCode: '',
                State : {
                    IdState: 1,
                    StateName: 'San josé',
                },
                AddressType : {
                    IdAddressType: 1,
                    Type: 'Casa',
                },
                Provincia: '',
                Canton: '',
                Distrito: '',
                Barrio: '',
                Direccion: '',
            }
        },
        populateAddressInfo() {
            if(this.extraParams.addresses[this.selectedAddressIndex] != undefined || this.extraParams.addresses[this.selectedAddressIndex] != null){
                this.address = this.extraParams.addresses[this.selectedAddressIndex];
            }
            else{
                this.setCity();
                this.setDistrict();
                this.setNeighborhood();
            }
        },
        handleSubmitStep3(scope) {
            this.submitted = true;
            this.$validator.validateAll(scope).then(valid => {
                if (valid) {
                    if(scope == 'form-3'){
                        this.$emit('updateConsignee', {consignee: this.Consignee, params: this.extraParams});
                    }
                    else if(scope == 'form-4'){
                        this.saveAddressData();
                        document.querySelector('.close.step3').click();
                        this.$validator.reset();
                    }
                }
            });
        },
    }
}
</script>

